export default "__VITE_ASSET__tvFAt5Va__"